import React from 'react';

/**
 * CurvedText — renders "CLASSIC CAR RESTORATION" along a half-moon arc
 * using an SVG textPath. The arc sits above the login card.
 */
export default function CurvedText() {
  return (
    <svg
      viewBox="0 0 340 180"
      width="340"
      height="180"
      aria-label="Classic Car Restoration"
      style={{ display: 'block', margin: '0 auto' }}
    >
      <defs>
        {/* Half-moon arc: starts bottom-left, curves up and over to bottom-right */}
        <path
          id="halfMoon"
          d="M 30,160 A 140,140 0 0,1 310,160"
          fill="none"
        />
      </defs>

      {/* Decorative track line */}
      <path
        d="M 30,160 A 140,140 0 0,1 310,160"
        fill="none"
        stroke="#5a3e00"
        strokeWidth="1"
        strokeDasharray="4 6"
        opacity="0.5"
      />

      {/* The curved text */}
      <text
        fontSize="17"
        fontWeight="800"
        fontFamily="'Georgia', 'Times New Roman', serif"
        letterSpacing="3.5"
        fill="#C8860A"
      >
        <textPath
          href="#halfMoon"
          textAnchor="middle"
          startOffset="50%"
        >
          CLASSIC CAR RESTORATION
        </textPath>
      </text>

      {/* Decorative dots at the ends of the arc */}
      <circle cx="30"  cy="160" r="3" fill="#C8860A" opacity="0.7" />
      <circle cx="310" cy="160" r="3" fill="#C8860A" opacity="0.7" />

      {/* Small gear icon in the center top of the arc */}
      <text
        x="170"
        y="38"
        textAnchor="middle"
        fontSize="22"
        fill="#C8860A"
        opacity="0.85"
      >
        ⚙
      </text>
    </svg>
  );
}
